import React, { useState, useEffect, useCallback } from 'react';
import useWebSocket, { ReadyState } from 'react-use-websocket';

const SERVER_HOST = '127.0.0.1';
const SERVER_PORT = 5052;

const App = () => {
  console.log('App component rendered');
  const [chatLog, setChatLog] = useState([]);
  const [messageInput, setMessageInput] = useState('');

  // Use the useWebSocket hook
  const { sendJsonMessage, lastMessage, readyState } = useWebSocket(`ws://${SERVER_HOST}:${SERVER_PORT}`);

  const appendMessage = (sender, message) => {
    setChatLog((prevChatLog) => [...prevChatLog, `${sender}: ${message}`]);
  };

  useEffect(() => {
    if (lastMessage !== null) {
      if (lastMessage.data.startsWith('Invalid input:')) {
        console.log('Received invalid input message from server:', lastMessage.data);
        appendMessage('Server', lastMessage.data);
      } else {
        const receivedNumber = Number(lastMessage.data);
        if (!isNaN(receivedNumber)) {
          console.log('Received message from server:', receivedNumber);
          appendMessage('Server', receivedNumber);
        } else {
          console.log('Received message from server is not a valid number:', lastMessage.data);
          // Handle the case when the received message is not a valid number
        }
      }
    }
  }, [lastMessage]);

  const sendMessage = useCallback(() => {
    console.log('Sending message...');
    const number = Number(messageInput.trim());
    if (!isNaN(number)) {
      console.log('Sent number from client:', number);
      appendMessage('Client', number);
      sendJsonMessage(number); // Send the number directly
      setMessageInput('');
    } else {
      console.log('Invalid input. Please enter a number.');
    }
  }, [messageInput, sendJsonMessage]);
  

  return (
    <div>
      <h1>WebSocket Client</h1>

      <div id="chat-box">
        <div id="chat-log">
          {chatLog.map((message, index) => (
            <div key={index}>{message}</div>
          ))}
        </div>
        <input
          type="text"
          id="message-input"
          placeholder="Type a message..."
          value={messageInput}
          onChange={(e) => setMessageInput(e.target.value)}
        />
        <button id="send-button" onClick={sendMessage} disabled={readyState !== ReadyState.OPEN}>
          Send
        </button>
      </div>
    </div>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js